module.exports = __webpack_public_path__ + "img/ch.c889f18d.svg";